import React from "react";
import '../../../styles/_base.scss'
import { Card, CardBody, Row, Col, Label, Button, Alert, } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Select, Textbox } from "react-inputs-validation";
import "../../../styles/estilos.css";
import { ambienteAplicacion, urlConsultarCedula } from '../../../constants/urls'
import { apiGet } from '../../../api'
import { ErrorMsgConstants, infoIds, tipoCotizacion } from '../../../constants'
import Select1 from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { ProvinciasPymesFetch, CoberturasPymesFetch, FetchGirosNegociosPymesDiners} from "../../../redux/actions/aRamoPymes";
import { estaEnListaNegra, isDuplicateHogar, LimpiarListaNegra } from "../../../redux/actions/ACarritoProductos";
import { ramos } from "../../../utils/constants";
import {arraySucursales} from "../../../redux/selectors/varios";

class CotizacionPymesDiners extends React.Component {

  constructor(props) {
    super(props);
    const { ubicaciones = '', codGiroNegocio = '', adicional = '', arraySucursales, datosAsesor, sucursalAsesor } = this.props
    this.state = {
      validate: false,
      ubicacion: ubicaciones ? ubicaciones : 1,
      codGiroNegocio,
      arrayDatosContratante: { cliIdentificacion: '', cliCodigoTipoDocumento: '', cliTipoDocumento: '', cliPersoneria: '', nombres: '', apellidos: '', direccion: '', celular:'', correo:'' },
      codigoRamo: -1,
      alert: '',
      esruc: false,
      arraySucursales: arraySucursales ? arraySucursales : '',
      sucursalAsesor: sucursalAsesor,

      hasUbicacionError: false,
      hasgiroError: !codGiroNegocio,
      adicional: adicional && adicional.trim() !== '' ? adicional : "Completa",
      selecadicional: !!(adicional && adicional.trim() !== ''),
      hasCedulaError: true,
      hasCodTipoDocError: true,
      hasNombreError: true,
      hasPersoneriaError: true,
      hasAdicionalError: true,
      loading: false,
      hasDireccionError: true,
      nombreProducto:'',
      codigoProducto:'pymesDiners',

    };
  }



  componentDidMount() {
    
    // Determinar el codigo de ramo, para el giro de negocio guardado
    if (this.state.codGiroNegocio) {
      this.props.infoPymes.girosNegocio.forEach(item => {
        if (item._id === this.state.codGiroNegocio) {
          this.setState({ codigoRamo: item.ramo });
        }
      })
    }


      this.setState({ adicional: "Completa" });


    if (arraySucursales.length > 0) {
      this.setState({ sucursalAsesor: arraySucursales[0] });


     // console.log("PRIMEROOOOO",this.state);
    }

    // set timeout
    setTimeout(() => {
      const { arrayDatosContratante } = this.props
      if (arrayDatosContratante) {
        let esruc = false;
        if (arrayDatosContratante.cliTipoDocumento === 'Ruc') esruc = true

        this.setState({ validate: true, arrayDatosContratante, esruc })
      }
      else {
        this.setState({ validate: true })
      }
    }, 1000);

  }
  tgglevalidate = (validate) => {
    this.setState({ validate });
  }

  // validar y continuar al siguiente paso
  onClick = async () => {

    this.tgglevalidate(true)
    const { ubicacion, codGiroNegocio, hasCedulaError, hasCodTipoDocError, hasNombreError, hasPersoneriaError, hasUbicacionError, hasgiroError, selecadicional, hasAdicionalError, hasDireccionError, nombreProducto, codigoProducto, codigoRamo } = this.state
    let { arrayDatosContratante, adicional, sucursalAsesor } = this.state

    // llamar al servicio de validación de duplicidad
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: this.state.arrayDatosContratante.cliIdentificacion,
      ramo: this.state.codigoRamo,
    };
    //console.log('checkDuplicidadObj pymes', checkDuplicidadObj,);
    await this.props.checkIsDuplicate({ type: 'pymes', postObj: checkDuplicidadObj });

    const datosAsesor = {

      sucursalSeleccionada: this.props.datosSucursales
        .sucursalSelecionadaAsesor,

      ambiente: ambienteAplicacion,
      emailAsesor: this.props.datosUsuarios.correo
        ? this.props.datosUsuarios.correo
        : "",
      nombreProducto: nombreProducto,
      codigoProducto: codigoProducto,
      codigoRamo: codigoRamo,
      nombreRamo: ramos.PYMES.nombre,
      codGiroNegocio: codGiroNegocio,

    }

    
    // validar si existe duplicidad o errores antes de continuar
    if (this.props.duplicity.isDuplicatePoliza === false) {
     

        if (!hasCedulaError && !hasCodTipoDocError && !hasNombreError && !hasPersoneriaError && !hasUbicacionError && !hasgiroError && !(selecadicional && hasAdicionalError) && !hasDireccionError && !this.props.duplicity.duplicidadPolizaError) {
          const { listaIdentificacion } = this.props
          const { name } = listaIdentificacion.find(({ id }) => id === arrayDatosContratante.cliCodigoTipoDocumento)
          arrayDatosContratante.cliTipoDocumento = name



          arrayDatosContratante.apellidos = arrayDatosContratante.apellidos.trim()
          arrayDatosContratante.direccion = arrayDatosContratante.direccion.trim()
          arrayDatosContratante.nombres = arrayDatosContratante.nombres.trim()
          arrayDatosContratante.celular = arrayDatosContratante.celular.trim()
          arrayDatosContratante.correo = arrayDatosContratante.correo.trim()


          this.props.handleNext({ numUbicaciones:1,ubicaciones: ubicacion, codGiroNegocio, visible: 2, arrayDatosContratante, adicional, sucursalAsesor, codigoProducto:"pymesDiners" })
        }
        else this.setState({ alert: 'Complete todos los campos' })

      

    }
  }

  getTipoDocumentos(personeria) {
    const { listaIdentificacion } = this.props
    let listado = listaIdentificacion.filter((tipo) => (parseInt(tipo.personeria) === parseInt(personeria) || !tipo.personeria))
    return listado;
  }
  consultaCargarDatos = async params => {
    const { cedula, tipo } = params;
    const data = await apiGet(urlConsultarCedula + cedula)
    //console.log("DATA", data)
    const { razon_social = '', apellido1 = '', apellido2 = '', nombre1 = '', nombre2 = '', direcciones = '', direccion = '' , celular='', correo=''} = data
    if (cedula.length === 13)
      this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: `${razon_social ? razon_social : ""} `, apellidos: `${razon_social ? razon_social : ""}`, direccion: `${direccion ? direccion : ''}` , celular: `${celular ? celular : ''}`, correo: `${correo ? correo : ''}`  },  validate: false, loading: false }))
    else
      this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: `${nombre1 ? nombre1 : ""} ${nombre2 ? nombre2 : ""}`, apellidos: `${apellido1 ? apellido1 : ""} ${apellido2 ? apellido2 : ""}`, celular: `${celular ? celular : ''}`, correo: `${correo ? correo : ''}` , direccion: `${direcciones ? direcciones : ''}` }, validate: false, loading: false }))
    setTimeout(() => this.setState({ validate: true }), 100)

  }
  componentDidUpdate(prevProps, prevState) {
    const { ubicaciones, codGiroNegocio, arrayDatosContratante } = this.props

    if (ubicaciones !== prevProps.ubicaciones || codGiroNegocio !== prevProps.codGiroNegocio) {
      let adicional = this.props.data.find(item => item._id === codGiroNegocio).adicional
      this.setState({ ubicacion: ubicaciones, codGiroNegocio, adicional })
    }
    if (arrayDatosContratante !== prevProps.arrayDatosContratante || arrayDatosContratante !== prevProps.arrayDatosContratante) this.setState({ arrayDatosContratante })

    if (this.state.codGiroNegocio !== prevState.codGiroNegocio) {
      if (this.state.codGiroNegocio)
        this.setState({ hasgiroError: false })
      else this.setState({ hasgiroError: true })
    }

    if (prevProps.arrayDatosContratante !== this.props.arrayDatosContratante && this.props.arrayDatosContratante !== this.state.arrayDatosContratante) {
      let esruc = false;
      if (this.props.arrayDatosContratante.cliTipoDocumento === 'Ruc') esruc = true

      this.setState({ validate: true, arrayDatosContratante, esruc })
    }

  }

  consultarCoberturas = async (giroNegocio) => {

    //console.log('select1change ', giroNegocio)


    await this.props.CoberturasPymesFetch({ giroNegocio: giroNegocio })



  }

  //ubicaciones gironegocio
  render() {

    //console.log("ESTADOOOOOOOOOOOOOO", this.state)

    const { loading, validate, ubicacion, codGiroNegocio, alert, arrayDatosContratante, esruc, adicional, selecadicional, sucursalAsesor } = this.state;
    const { data2 } = this.props
    let { listaPersoneria, arraySucursales } = this.props
    const { cliIdentificacion, cliCodigoTipoDocumento, cliPersoneria, nombres, apellidos, direccion, celular, correo } = arrayDatosContratante
    let defaulGiro = data2.filter(item => item.value === codGiroNegocio)




    return (
      <LoadingScreen
        loading={loading || this.props.duplicity.duplicidadPolizaLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <Row className='container-body-spaces'>
          <Col lg={10} className="div-align-center">
            <Card className="flex-row ">
              <CardBody>

                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Seleccione la personería(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Select
                      //tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"personeria"} // Optional.[String].Default: "". Input ID.
                      name={"personeria"} // Optional.[String].Default: "". Input name.
                      value={cliPersoneria} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={listaPersoneria} // Required.[Array of Object(s)].Default: [].
                      onChange={(cliPersoneria, e) => {
                        this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliCodigoTipoDocumento: '', nombres: '', apellidos: '', celular: '', correo: '' }, hasPersoneriaError: cliPersoneria ? false : true }))
                      }
                      }
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={res => this.setState({ hasPersoneriaError: res, validate: false })}
                      validationOption={{
                        name: "personeria", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione la personería"
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Seleccione tipo de documento(*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Select
                      //tabIndex="6" // Optional.[String or Number].Default: none.
                      id={"selectTipoDoc"} // Optional.[String].Default: "". Input ID.
                      name={"selectTipoDoc"} // Optional.[String].Default: "". Input name.
                      value={cliCodigoTipoDocumento} // Optional.[String].Default: "".
                      validate={validate}
                      optionList={this.getTipoDocumentos(cliPersoneria)} // Required.[Array of Object(s)].Default: [].
                      onChange={(cliCodigoTipoDocumento) => this.setState(prevState => ({
                        arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliCodigoTipoDocumento },
                        esPasaporte: cliCodigoTipoDocumento === infoIds.codigoPasaporteStr ? true : false, esruc: cliCodigoTipoDocumento === infoIds.codigoRucStr ? true : false,
                        hasCodTipoDocError: cliCodigoTipoDocumento ? false : true,
                      }))}
                      // Optional.[Func].Default: () => {}. Will return the value.
                      onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      //customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                      validationCallback={res => this.setState({ hasCodTipoDocError: res, validate: false })}
                      validationOption={{
                        name: "selectTipoDoc", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor seleccione el tipo de documento"
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Número de Identificación (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      tabIndex="1"
                      type="text"
                      id="cedula"
                      name="cedula"
                      classNameInput={"form-control"}
                      value={cliIdentificacion}
                      validate={validate}
                      onChange={(cliIdentificacion, e) => {
                        this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, cliPersoneria, cliIdentificacion } }))
                        if ((this.state.esruc && (cliIdentificacion.length === 13 && cliCodigoTipoDocumento === infoIds.codigoRucStr)) || (!this.state.esruc && (cliIdentificacion.length === 10 && cliCodigoTipoDocumento === infoIds.codigoCedulaStr))) {
                          this.setState({ loading: true })
                          this.consultaCargarDatos({ cedula: cliIdentificacion, tipo: 1 })
                        }
                      }}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasCedulaError: res, validate: false })}
                      validationOption={{
                        name: "cedula",
                        check: true,
                        required: true,
                        reg: this.state.esruc
                            ? /^\d{13}$/
                            : this.state.esPasaporte
                                ? /^[A-Za-z0-9]*$/
                                : /^\d{10}$/,
                        msgOnError: this.state.esruc
                            ? "Por favor ingrese un RUC válido (13 números)"
                            : this.state.esPasaporte
                                ? "Por favor ingrese el pasaporte, no debe tener caracteres especiales"
                                : "Por favor ingrese una cédula válida (10 números)"
                      }}

                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>{cliCodigoTipoDocumento !== infoIds.codigoRucStr ? "Nombres (*)" : "Razón Social (*)"}</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      type="text"
                      id="nombres"
                      name="nombres"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={nombres}
                      onChange={(nombres, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, nombres: nombres.trimStart() } }))}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                      validationOption={{
                        name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        reg: cliCodigoTipoDocumento !== infoIds.codigoPasaporteStr
                            ? /^[A-Za-z ]*$/
                            : /^[A-Za-z. ]*$/,

                        required: true,
                        msgOnError:
                            `Por favor ingrese ${cliCodigoTipoDocumento !== infoIds.codigoRucStr ? "los nombres" : " la razón social"}, no deben tener caracteres especiales`
                      }}
                    />
                  </Col>
                </Row>

                {!esruc &&
                  <Row>
                    <Col lg={4} md={4} sm={4} >
                      <h5>Apellidos (*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} >
                      <Textbox
                        type="text"
                        id="apellidos"
                        name="apellidos"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={apellidos}
                        onChange={(apellidos, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, apellidos: apellidos.trimStart() } }))}
                        onBlur={() => { }}
                        validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                        validationOption={{
                          name: "apellidos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          reg: /^[A-Za-z ]*$/,
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor ingrese los apellidos, no deben tener caracteres especiales"
                        }}
                      />
                    </Col>
                  </Row>
                }


                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Celular (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                        type="text"
                        id="celular"
                        name="celular"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={celular}
                        onChange={(celular, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, celular: celular.trimStart() } }))}
                        onBlur={() => { }}
                        validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                        validationOption={{
                          name: "celular", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          reg: /^[0-9]{10,}$/,
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor el celular, debe tener mínimo 10 dígitos"
                        }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>Correo (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                        type="text"
                        id="correo"
                        name="correo"
                        validate={validate}
                        classNameInput={"form-control"}
                        value={correo}
                        onChange={(correo, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, correo: correo.trimStart() } }))}
                        onBlur={() => { }}
                        validationCallback={res => this.setState({ hasNombreError: res, validate: false })}
                        validationOption={{
                          name: "correo",
                          check: true,
                          reg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          required: true,
                          msgOnError: "Por favor ingrese un correo válido (ej: ejemplo@dominio.com)"
                        }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} >
                    <h5>{"Dirección"} (*)</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} >
                    <Textbox
                      type="text"
                      id="direccion"
                      name="direccion"
                      validate={validate}
                      classNameInput={"form-control"}
                      value={direccion}
                      onChange={(direccion, e) => this.setState(prevState => ({ arrayDatosContratante: { ...prevState.arrayDatosContratante, direccion: direccion.trimStart() } }))}
                      onBlur={() => { }}
                      validationCallback={res => this.setState({ hasDireccionError: res, validate: false })}
                      validationOption={{
                        name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                        reg: /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,/-]*$/,
                        required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        msgOnError: "Por favor ingrese una dirección, no debe tener caracteres especiales"
                      }}
                    />
                  </Col>
                </Row>


                <Row className="mb-3">
                  <Col md={4}  >
                    <h5><Label className="bold-font-label" > Giro del negocio </Label></h5>
                  </Col>
                  <Col md={8} >

                    <Select1
                        value={defaulGiro}
                        components={makeAnimated()}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderColor: this.state.hasgiroError ? '#dc3545' : base.borderColor,
                            '&:hover': {
                              borderColor: this.state.hasgiroError ? '#dc3545' : base.borderColor
                            }
                          }),

                        }}
                        onChange={({ adicional, label, value, codRamo, codigoProducto, nombreProducto }) => {
                          // ✅ Llamar correctamente al método que sí está en props
                          this.props.FetchGirosNegociosPymesDiners();

                          // Lógica para coberturas
                          this.consultarCoberturas(value);

                          // Actualizar estado
                          this.setState({
                            codigoProducto: codigoProducto,
                            codRamo: codRamo,
                            nombreProducto: nombreProducto,
                            codGiroNegocio: value,
                            giroNombre: label,
                            selecadicional: adicional,
                            codigoRamo: codRamo,
                            hasgiroError: value ? false : true,
                          });
                        }}
                        onBlur={() => {
                          if (!this.state.codGiroNegocio) {
                            this.setState({ hasgiroError: true });
                          }
                        }}
                        options={data2}
                        isSearchable={true}
                        placeholder={"Seleccione una opción"}
                        isMulti={false}
                        className={this.state.hasgiroError ? 'is-invalid' : ''}
                        classNamePrefix="react-select"
                    />
                    {this.state.hasgiroError && (
                        <div className="invalid-feedback d-block">
                          Por favor seleccione un giro de negocio
                        </div>
                    )}
                  </Col>
                </Row>




                {/*this.props.datosAsesor && this.props.datosAsesor.usu_tipo_usuario !== 'cliente' &&

                                      <Row>
                    <Col lg={4} md={4} sm={12} xs={12}><h5><Label for="exampleSelect" className="bold-font-label" >Sucursal de Emisión</Label></h5></Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Select
                        tabIndex="6"
                        id={"SelectSucursal"}
                        name={"SelectSucursal"}
                        value={sucursalAsesor}
                        optionList={arraySucursales}
                        onChange={(selec, e) => {

                          this.setState({ 3: selec });
                        }}
                        validate={validate}
                        validationCallback={res =>
                          this.setState({
                            hasCiudadError: res,
                            validate: !res
                          })
                        }
                        onBlur={() => { }}
                        customStyleOptionListContainer={{}}
                        validationOption={{
                          name: "SelectCiudad",
                          check: true,
                          required: true,
                          msgOnError: "Por favor seleccione una sucursal"
                        }}
                      />
                    </Col>
                  </Row>
                */}

                <Row>
                  <div className="div-align-center">
                    <Button className="btn btn-primary" onClick={() => this.onClick()} style={{ display: "block", margin: "auto" }}>
                      <i className="fa fa-chevron-circle-right" aria-hidden="true" />{"  CONTINUAR"}
                    </Button>
                  </div>
                </Row>

                {/* Mensaje de error*/}
                <div style={{ marginTop: '2rem' }}>
                  {/* Validacion de duplicidad */}
                  {/*console.log('test dup msg', this.props.duplicity)*/}
                  {this.props.duplicity.isDuplicatePoliza
                    ?
                    <Alert color="danger">
                      <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                    </Alert>
                    :
                    null
                  }
                  {this.props.duplicity.duplicidadPolizaError &&
                    <Alert color="danger">
                      <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                    </Alert>
                  }
                </div>

                
              </CardBody>

            </Card>
          </Col>
        </Row >
      </LoadingScreen>
    );
  }
}

// const mapStateToProps = state => ({
//   listaPersoneria: state.catalogosCotizacion.personeria.tiposPersoneria,
//   data: state.dataPymes.girosNegocio,
//   //data2: state.dataPymes.girosNegocio.forEach(({ espanol, _id, adicional }, i) => this[i] = { label: espanol, value: _id, adicional }, state.dataPymes.girosNegocio),
//   listaIdentificacion: state.catalogosCotizacion.personeria.tiposIdentificacion
// });

const mapStateToProps = state => {
  const data = state.dataPymes.girosNegocio || [];
  const data2 = data
      .filter(item => item && item._id && item.espanol)
      .map(({ espanol, _id, adicional, ramo, codigoProducto, nombreProducto }) => ({
        label: espanol,
        value: _id,
        adicional,
        codRamo: ramo,
        codigoProducto,
        nombreProducto
      }));

  return {
    data,
    data2,
    listaPersoneria: state.catalogosCotizacion.personeria.tiposPersoneria,
    listaIdentificacion: state.catalogosCotizacion.personeria.tiposIdentificacion,
    duplicity: state.datosDuplicidadPolizas,
    datosListaNegra: state.datosListaNegra,
    infoPymes: state.dataPymes,
    datosUsuarios: state.datosUsuarios.dataUsuario,
    datosSucursales: state.datosSucursales,
    codigoProducto: "pymesDiners"
  }
}

const mapDispatchToProps = dispatch => ({
  FetchGirosNegociosPymesDiners: () => dispatch(FetchGirosNegociosPymesDiners()),
  ProvinciasPymesFetch: () => dispatch(ProvinciasPymesFetch()),
  CoberturasPymesFetch: (data) => dispatch(CoberturasPymesFetch(data)),
  checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
  
 
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps, // null
  )(CotizacionPymesDiners)
);
